/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  KillswitchesListCapabilitiesRequest,
  KillswitchesListCapabilitiesSecurity,
} from "../models/operations/killswitcheslistcapabilities.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildKillswitchCapabilitiesQuery,
  KillswitchCapabilitiesQueryData,
  prefetchKillswitchCapabilities,
  queryKeyKillswitchCapabilities,
} from "./killswitchCapabilities.core.js";
export {
  buildKillswitchCapabilitiesQuery,
  type KillswitchCapabilitiesQueryData,
  prefetchKillswitchCapabilities,
  queryKeyKillswitchCapabilities,
};

export type KillswitchCapabilitiesQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listCapabilities killswitches
 */
export function useKillswitchCapabilities(
  security: KillswitchesListCapabilitiesSecurity,
  request?: KillswitchesListCapabilitiesRequest | undefined,
  options?: QueryHookOptions<
    KillswitchCapabilitiesQueryData,
    KillswitchCapabilitiesQueryError
  >,
): UseQueryResult<
  KillswitchCapabilitiesQueryData,
  KillswitchCapabilitiesQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildKillswitchCapabilitiesQuery(
      client,
      security,
      request,
      options,
    ),
    ...options,
  });
}

/**
 * listCapabilities killswitches
 */
export function useKillswitchCapabilitiesSuspense(
  security: KillswitchesListCapabilitiesSecurity,
  request?: KillswitchesListCapabilitiesRequest | undefined,
  options?: SuspenseQueryHookOptions<
    KillswitchCapabilitiesQueryData,
    KillswitchCapabilitiesQueryError
  >,
): UseSuspenseQueryResult<
  KillswitchCapabilitiesQueryData,
  KillswitchCapabilitiesQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildKillswitchCapabilitiesQuery(
      client,
      security,
      request,
      options,
    ),
    ...options,
  });
}

export function setKillswitchCapabilitiesData(
  client: QueryClient,
  queryKeyBase: [parameters: { gramSession?: string | undefined }],
  data: KillswitchCapabilitiesQueryData,
): KillswitchCapabilitiesQueryData | undefined {
  const key = queryKeyKillswitchCapabilities(...queryKeyBase);

  return client.setQueryData<KillswitchCapabilitiesQueryData>(key, data);
}

export function invalidateKillswitchCapabilities(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: [
      "@gram/client",
      "killswitches",
      "listCapabilities",
      ...queryKeyBase,
    ],
  });
}

export function invalidateAllKillswitchCapabilities(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "killswitches", "listCapabilities"],
  });
}
